import { Observable, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SnPlayerService {
  private _fullscreen$ = new Subject<string>();

  get fullscreen$(): Observable<string> {
    return this._fullscreen$.asObservable();
  }

  constructor() {}

  public fullscreenOpen(): void {
    this._fullscreen$.next('open');
  }

  public fullscreenClose(): void {
    this._fullscreen$.next('close');
  }
}
